import { forwardRef } from "react";
import clsx from 'clsx';
import Card, { CardProps } from "./Card";
import BubbleStyle from "./css/Bubble.module.css";

type TailPosition = "top" | "bottom" | "left" | "right" | "top-left" | "top-right";
type TailAlign = "start" | "center" | "end";

type BubbleProps = CardProps & {
    tailPosition?: TailPosition;
    tailAlign?: TailAlign;
    backgroundColor?: string;
    onClose?: () => void;
    closeColor?: string;
};

const Bubble = forwardRef<HTMLDivElement, BubbleProps>(({
    children,
    shadow = 12,
    shadowDirection = "default",
    gray = false,
    border = 1,
    borderRadius = 12,
    fullWidth = false,
    closeColor,
    padding,
    paddingX,
    paddingY,
    width,
    height,
    shadowAlpha = 0.08,
    tailPosition = "bottom",
    tailAlign = "center",
    backgroundColor,
    onClose,
    style,
    className,
    ...props
}, ref) => {
    // 배경색 결정: backgroundColor prop > gray 설정 > 기본 white
    const bgColor = backgroundColor || (gray ? 'rgba(249, 249, 249, 1)' : 'white');
    
    // tail 클래스 결정
    const getTailClass = () => {
        switch(tailPosition) {
            case "top": return BubbleStyle["bubble-tail-top"];
            case "bottom": return BubbleStyle["bubble-tail-bottom"];
            case "left": return BubbleStyle["bubble-tail-left"];
            case "right": return BubbleStyle["bubble-tail-right"];
            case "top-left": return BubbleStyle["bubble-tail-top-left"];
            case "top-right": return BubbleStyle["bubble-tail-top-right"];
            default: return BubbleStyle["bubble-tail-bottom"];
        }
    };

    return (
        <div 
            ref={ref}
            className={clsx(BubbleStyle["bubble-wrapper"], className)}
            style={style}
            {...props}
        >
                <Card
                    shadow={shadow}
                    shadowDirection={shadowDirection}
                    gray={gray}
                    border={border}
                    borderRadius={borderRadius}
                    fullWidth={fullWidth}
                    padding={padding}
                    paddingX={paddingX}
                    paddingY={paddingY}
                    width={width}
                    height={height}
                    shadowAlpha={shadowAlpha}
                    className={BubbleStyle["bubble-card"]}
                    style={{
                        backgroundColor: bgColor
                    }}
                >
                    <div className={BubbleStyle["bubble-content"]}>
                        <div className={BubbleStyle["bubble-text"]}>
                            {children}
                        </div>
                        {onClose && (
                            <button 
                                className={BubbleStyle["bubble-close-btn"]}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onClose();
                                }}
                                style={{ color: closeColor }}
                                aria-label="닫기"
                            >
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                        )}
                    </div>
                </Card>
            <div 
                className={clsx(
                    BubbleStyle["bubble-tail"],
                    getTailClass()
                )}
                style={{
                    ['--border-color' as any]: border ? 'rgba(221, 221, 221, 1)' : 'transparent',
                    ['--bg-color' as any]: bgColor,
                }}
            />
        </div>
    );
});

Bubble.displayName = "Bubble";

export default Bubble;

